import React from "react";
import HeroSection from "./HeroSection";
import StorySection from "./StorySection";
import PhilosophySection from "./PhilosophySection";
import ApproachSection from "./ApproachSection";
import ExpertiseSection from "./ExpertiseSection";
import FounderSection from "./FounderSection";
import ContactSection from "./ContactSection";
import { Box } from "@mui/material";
import ScheduleSection from "./SheduleSection";

export default function HomePage() {
  return (
    <Box sx={{ pt: "7rem" }}>
      <HeroSection id="hero" />
      <StorySection id="story" />
      <PhilosophySection id="philosophy" />
      <ApproachSection id="approach" />
      <ExpertiseSection id="expertise" />
      <FounderSection id="founder" />
      <ContactSection id="contact" />
      <ScheduleSection />
    </Box>
  );
}
